/** Read preparation feedback in the builder without starting a Flow operation. */
import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { Button, Message } from 'semantic-ui-react';
import FlowDiagnostics from './FlowDiagnostics';

export function BuilderFlowDiagnostics({ questionnaire, token, onSection }) {
  const [result, setResult] = useState(null);
  const [error, setError] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const id = questionnaire?.id, tenantId = questionnaire?.tenantId;
  const enabled = process.env.REACT_APP_FLOW_DRAFT_ADMIN === 'true' && id && tenantId && token && questionnaire.whatsappFlowsEnabled !== false;
  const reload = useCallback(() => setRefresh(value => value + 1), []);
  useEffect(() => {
    let cancelled = false;
    setResult(null);
    setError(false);
    if (enabled) axios({ method: 'get',
      url: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_ENV}/whatsapp-flows/draft`,
      params: { tenantId, questionnaireId: id }, headers: { Authorization: `Bearer ${token}` },
    }).then(({ data }) => { if (!cancelled) setResult(data); })
      .catch(() => { if (!cancelled) setError(true); });
    return () => { cancelled = true; };
  }, [enabled, id, tenantId, token, questionnaire?.updatedAt, refresh]);
  if (!enabled) return null;
  const diagnostics = (result?.diagnostics || []).filter(d => d?.message?.trim());
  const failed = ['validation_failed', 'failed', 'reconciliation_required', 'publication_uncertain'].includes(result?.status);
  const pending = ['queued', 'generating', 'preparing_review', 'publication_queued', 'publishing'].includes(result?.status);
  if (!diagnostics.length && !error && !failed && !pending) return null;
  return <section aria-label="WhatsApp Flow feedback">
    <FlowDiagnostics diagnostics={diagnostics} onSection={onSection} />
    {failed && !diagnostics.some(d => d.severity !== 'warning') && <Message color="red"
      header="The WhatsApp Flow could not be prepared or published"
      content="Your questionnaire edits are saved. Open Flow management in the questionnaire settings for the operation details. If there is no specific correction shown, contact Wakamoso support." />}
    {error && <Message color="orange" content="We could not check the WhatsApp Flow status. Your questionnaire is still available to edit. Check again or open Flow management in settings." />}
    {pending && <p role="status">The WhatsApp Flow is being prepared. Check again shortly for the result.</p>}
    <Button type="button" basic size="small" onClick={reload}>Check Flow status</Button>
  </section>;
}
export default connect(state => ({ token: state.authData?.[0]?.signInUserSession?.accessToken?.jwtToken }))(BuilderFlowDiagnostics);
